import { useMemo } from "react"
import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../../../../modules/localization/components/AppLocalized"
import { MinMaxTimeLimitsProps } from "./useDeliveryTimeLimits"

const useStyles = makeStyles()((theme) => ({
    message: {
        color: theme.palette.tailwind.red[950],
        background: theme.palette.tailwind.red[100],
        borderRadius: ".5rem",
        padding: ".75rem 1rem",
        fontWeight: "500",
        marginBottom: ".5rem",
    },
}))

type DeliveryTimeWarningProps = {
    isToday: boolean
    minMaxTime: MinMaxTimeLimitsProps
}

export function DeliveryTimeWarning({ isToday, minMaxTime }: DeliveryTimeWarningProps) {
    const { classes } = useStyles()

    const formattedMinTime = useMemo(() => {
        return minMaxTime?.minTime?.toFormat("HH:mm") ?? ""
    }, [minMaxTime?.minTime?.toISO()])

    const formattedMaxTime = useMemo(() => {
        return minMaxTime?.maxTime?.toFormat("HH:mm") ?? ""
    }, [minMaxTime?.maxTime?.toISO()])

    return isToday ? (
        <LocalizedStrict
            id="create-order-delivery-times-dialog-delivery-time-event-start-today"
            vars={{ time: formattedMaxTime }}
        >
            <Typography variant="body2" className={classes.message}>
                Unfortunately you can't create a meeting service order today, because merchant does not deliver later
                than {formattedMaxTime}
            </Typography>
        </LocalizedStrict>
    ) : (
        <LocalizedStrict
            id="create-order-delivery-times-dialog-delivery-time-event-start"
            vars={{ minTime: formattedMinTime, maxTime: formattedMaxTime }}
        >
            <Typography variant="body2" className={classes.message}>
                Unfortunately you can't create a meeting service order. Merchant delivers only between{" "}
                {formattedMinTime} and {formattedMaxTime}
            </Typography>
        </LocalizedStrict>
    )
}
